// extracted by mini-css-extract-plugin
module.exports =  {"container":"TSklZnVXNxSq6yTuHUxH","title":"Igyqz3T5EpgskrpKJLgQ","link":"XLcVsPPsF7l057M56UCe"};